import { render, staticRenderFns } from "./resultList.vue?vue&type=template&id=7b2cf736&scoped=true&"
import script from "./resultList.vue?vue&type=script&lang=js&"
export * from "./resultList.vue?vue&type=script&lang=js&"
import style0 from "./resultList.vue?vue&type=style&index=0&id=7b2cf736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cf736",
  null
  
)

export default component.exports